import * as React from 'react';
import { HelpCircle } from 'react-feather';

export function DefaultDomInputHelpIconContent() {
  return <HelpCircle />;
}
